<template>
  <div class="container">
    <head-nav-bar title="会员消费记录" :fixed="true"> </head-nav-bar>
    <div class="mt-header-nav">
      <van-search
        placeholder="请输入搜索关键词"
        style="border-bottom:1px solid #f1f1f1;"
        v-model="keyword"
        @search="onSearch"
      />
      <data-list
        :api="getMemberAccountRecord"
        :params="listParams"
        style="height:calc(100vh - 115px)"
      >
        <template v-slot:item="item">
          <div class="card-list-item">
            <van-row gutter="20">
              <van-col span="16">
                <p>客人账号：{{ item.GuestId }}</p>
              </van-col>
              <van-col span="8">
                <p style="text-align:right;">{{ item.AccountDate }}</p>
              </van-col>
            </van-row>
            <van-row gutter="20">
              <van-col span="16">
                <p>{{ item.CompanyNmae }} {{ item.CategoryName }}</p>
              </van-col>
              <van-col span="8">
                <p style="text-align:right;">{{ item.CreatorUserName }}</p>
              </van-col>
            </van-row>
            <van-row gutter="20" style="color:#555;">
              <van-col span="16">
                <p>消费金额： {{ item.Amount }}</p>
              </van-col>
              <van-col span="8">
                <p>余额： {{ item.Balance }}</p>
              </van-col>
            </van-row>
            <p>备注：{{ item.Remark }}</p>
          </div>
        </template>
      </data-list>
    </div>
  </div>
</template>

<script>
import { getMemberAccountRecord } from "@/api/member.js";

import { SwipeCell, Button, Search, Notify, Cell, Row, Col } from "vant";
import DataList from "@/components/DataList";

export default {
  components: {
    [SwipeCell.name]: SwipeCell,
    [Button.name]: Button,
    [Search.name]: Search,
    [Cell.name]: Cell,
    [Row.name]: Row,
    [Col.name]: Col,
    DataList,
  },
  data() {
    return {
      getMemberAccountRecord,
      listParams: {},
      keyword: "",
    };
  },
  created() {
    const id = this.$route.query.Id;
    if (!id) {
      Notify("缺少必要参数!");
      setTimeout(() => {
        this.$router.go(-1);
      }, 2000);
      return false;
    }
    this.listParams = {
      MemberCardId: id,
    };
  },
  methods: {
    onSearch() {
      this.listParams = {
        Keyword: this.keyword,
      };
    },
  },
};
</script>

<style lang="less" scoped>
.card-list-item {
  padding: 16px;
  line-height: 1.6;
  color: #999;
}
</style>
